<template>

    <section
        class="brands-banner"
        ref="section"
    >
        <div
            ref="bannerContainer"
            :style="{transform: 'translateX(-' + offsetWidth + 'px)', width:totalWidth + 'px'}"
        >
            <inertia-link
                v-for="(brand, index) in bannerBrands"
                :key="index"
                :href="route('products.brand-products', {brand_slug:brand.slug})"
            >
                <img
                    :src="brand.image"
                    :alt="brand.name"
                />
            </inertia-link>
        </div>
    </section>

</template>

<script>

export default {

    computed: {
        bannerBrands() {
            return this.$page.props.brands.data.filter(brand => brand.image !== null);
        },

        offsetWidth() {
            if (this.imageOffset === 0 || this.loaded === false || !this.$refs.bannerContainer) {
                return 0;
            }

            let offsetWidth = 0;
            let imageOffset = this.imageOffset;

            Array.from(this.$refs.bannerContainer.children)
                .forEach(function (child, index) {
                    if (index >= imageOffset) {
                        return;
                    }

                    offsetWidth += child.clientWidth;
                });

            return offsetWidth;
        },

        sectionWidth() {
            if (!this.$refs.section) {
                return window.innerWidth;
            }

            return this.$refs.section.clientWidth;
        },
    },

    data() {
        return {
            imageOffset:0,
            loaded:false,
            totalWidth:100000,
        }
    },

    methods: {
        calcTotalWidth() {
            if (this.loaded === false || !this.$refs.bannerContainer) {
                return 0;
            }

            let totalWidth = 0;

            Array.from(this.$refs.bannerContainer.children)
                .forEach(child => totalWidth += child.clientWidth);

            return totalWidth;
        },

        moveNext() {
            if ((this.totalWidth - this.offsetWidth) < this.sectionWidth) {
                this.imageOffset = 0;
            } else {
                this.imageOffset++;
            }
        },

        setTotalWidth() {
            let calced = this.calcTotalWidth();

            calced === 0 ?
                setTimeout(() => this.setTotalWidth(), 300) :
                this.totalWidth = calced;
        },

        start() {
            this.loaded = true;
            this.setTotalWidth();
            setInterval(() => this.moveNext(), 3000);
        },
    },

    mounted() {
        window.addEventListener('load', () => this.start());
    },

    name:'HomepageBrandsBanner',

}

</script>
